import React from 'react';
import { Grid, Box, Typography, TextField, Button, FormControlLabel, FormControl, Checkbox, Select, MenuItem, InputLabel } from '@mui/material';

const ClientContact = (
    {
        clientContacts, clientContactNumbers, clientContactEmails,
        handleContactChange, handleAddContact, handleRemoveContact, handleContactDetailsChange,
        handleNumberChange, handleAddNumber, handleRemoveNumber,
        handleEmailChange, handleAddEmail, handleRemoveEmail,
        handleContactCheckboxChange }) => {
    const renderContactFields = (contact, index) => (
        <Box key={index} mb={6}> {/* Add space between contact persons */}
            <Grid container spacing={3}>
                {/* First Name and Last Name Fields */}
                <Grid item xs={3}>
                    <TextField
                        label="First Name"
                        fullWidth
                        value={contact.firstname}
                        onChange={(e) => handleContactChange(index, 'firstname', e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        label="Last Name"
                        fullWidth
                        value={contact.lastname}
                        onChange={(e) => handleContactChange(index, 'lastname', e.target.value)}
                    />
                </Grid>

                {/* Billing Contact and Remove Contact */}
                <Grid item xs={4}>
                    <Grid container spacing={3}>
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={contact.billing}
                                        onChange={() => handleContactCheckboxChange(index)}
                                    />
                                }
                                label="Billing Contact"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={2}>
                    <Grid container spacing={3}>   
                        {clientContacts.length > 1 && (
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    sx={{
                                        color: "#FF4C4C",
                                        borderColor: "#FF4C4C",
                                    }}
                                    onClick={() => handleRemoveContact(index)}
                                >
                                    Remove Contact
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                {/* Contact Type and Contact Number */}
                <Grid item xs={6}>
                    <Grid container spacing={3}>
                        {contact.numbers.map((number, numberIndex) => (
                            <React.Fragment key={numberIndex}>
                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="contact-type-label" sx={{ fontSize: '0.875rem' }}>Contact Type</InputLabel>
                                        <Select
                                            labelId="contact-type-label"
                                            value={number.type}
                                            onChange={(e) => handleContactDetailsChange(index, 'numbers', numberIndex, 'type', e.target.value)}
                                            label="Contact Type"
                                            sx={{ fontSize: '0.875rem' }}
                                        >
                                            <MenuItem value="mobile">Mobile</MenuItem>
                                            <MenuItem value="landline">Landline</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Contact Number"
                                        fullWidth
                                        value={number.number}
                                        onChange={(e) => handleContactDetailsChange(index, 'numbers', numberIndex, 'number', e.target.value)}
                                    />
                                </Grid>

                                {contact.numbers.length > 1 && (
                                    <Grid item xs={2}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => handleRemoveNumber(index, numberIndex)}
                                            size="small"
                                            sx={{
                                                color: "#FF4C4C",
                                                borderColor: "#FF4C4C",
                                            }}
                                        >
                                            Remove
                                        </Button>
                                    </Grid>
                                )}

                            </React.Fragment>
                        ))}
                    </Grid>

                    <Grid item xs={12} mt={2}>
                        <Button
                            variant="contained"
                            color="primary" 
                            onClick={() => handleAddNumber(index)}
                            size="small"
                        >
                            Add Number
                        </Button>
                    </Grid>
                </Grid>

                

                {/* Email Address */}
                <Grid item xs={6}>
                    <Grid container spacing={3}>
                        {contact.emails.map((email, emailIndex) => (
                            <React.Fragment key={emailIndex}>
                                <Grid item xs={9}>
                                    <TextField
                                        label="Email Address"
                                        fullWidth
                                        value={email.email}
                                        onChange={(e) => handleContactDetailsChange(index, 'emails', emailIndex, 'email', e.target.value)}
                                    />
                                </Grid>

                                {contact.emails.length > 1 && (
                                    <Grid item xs={2}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => handleRemoveEmail(index, emailIndex)}
                                            size="small"
                                            sx={{
                                                color: "#FF4C4C",
                                                borderColor: "#FF4C4C",
                                            }}
                                        >
                                            Remove
                                        </Button>
                                    </Grid>
                                )}

                            </React.Fragment>
                        ))}
                    </Grid>

                    <Grid item xs={12} mt={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleAddEmail(index)}
                            size="small"
                        >
                            Add Email
                        </Button>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                {clientContacts.map((person, index) => renderContactFields(person, index))}
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddContact}
                    size="small"
                >
                    Add Contact Person
                </Button>
            </Grid>

        </Grid>
    );
};

export default ClientContact;
